import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import { FiChevronDown, FiChevronUp, FiShoppingBag } from "react-icons/fi";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [openSection, setOpenSection] = useState("description");

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? "" : section);
  };

  // Color mapping for swatches
  const colorMap = {
    White: "#ffffff",
    Black: "#000000",
    Navy: "#1c2b4c",
    Beige: "#e5d3b3",
    "Light Blue": "#add8e6",
    Grey: "#8c8c8c",
    Burgundy: "#800020",
    "Grey Melange": "#a9a9a9",
    Olive: "#556b2f",
    Brown: "#5c4033",
    Camel: "#c19a6b",
    Charcoal: "#36454f",
    "Brown Striped": "#5c4033",
    "Black Striped": "#000000",
    "Pink Striped": "#ffc0cb",
    "Blue Striped": "#1c2b4c",
    "Green Striped": "#556b2f",
    "Grey Pattern": "#8c8c8c",
    "Brown Pattern": "#5c4033",
  };

  return (
    <div className="product-detail-container">
      <div className="breadcrumb">
        <Link to="/">Home</Link> &gt; <Link to="/shop">Great Offers</Link> &gt; <span>{product.category}</span>
      </div>

      <div className="product-detail">
        <div className="product-detail__images">
          {product.images?.slice(0, 4).map((img, idx) => (
            <img key={idx} src={img} alt={`${product.name} ${idx + 1}`} />
          ))}
        </div>

        <div className="product-detail__info">
          <h1 className="product-title">{product.name.toUpperCase()}</h1>
          <p className="product-price">${product.price}</p>

          <div className="product-color">
            <p>Colour: {selectedColor}</p>
            <div className="color-swatches">
              {product.colors?.map((color, idx) => (
                <div
                  key={idx}
                  className={`color-swatch ${selectedColor === color ? "active" : ""}`}
                  style={{ backgroundColor: colorMap[color] || color.toLowerCase() }}
                  onClick={() => setSelectedColor(color)}
                ></div>
              ))}
            </div>
          </div>

          <div className="product-size">
            <div className="size-header">
              <span>Select a size</span> 
            </div>
            <div className="size-buttons">
              {product.size?.map((size, idx) => (
                <button
                  key={idx}
                  className={`size-btn ${selectedSize === size ? "active" : ""}`}
                  onClick={() => setSelectedSize(size)}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>

          <button className="add-to-bag-btn" onClick={handleAddToCart}>
            <span>ADD TO BAG</span>
            <FiShoppingBag />
          </button>

          <div className="product-accordions">
            <div className="accordion-item">
              <div
                className="accordion-header"
                onClick={() => toggleSection("description")}
              >
                <span>DESCRIPTION</span>
                {openSection === "description" ? <FiChevronUp /> : <FiChevronDown />}
              </div>
              {openSection === "description" && (
                <div className="accordion-content">
                  <ul className="features-list">
                    {product.Features?.map((feature, idx) => (
                      <li key={idx}>- {feature}</li>
                    ))}
                  </ul>
                  <div className="description-text">
                    {product.description?.map((para, idx) => (
                      <p key={idx}>{para}</p>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="accordion-item">
              <div
                className="accordion-header"
                onClick={() => toggleSection("material")}
              >
                <span>MATERIAL & CARE</span>
                {openSection === "material" ? <FiChevronUp /> : <FiChevronDown />}
              </div>
              {openSection === "material" && (
                <div className="accordion-content">
                  <p>{product.material}</p>
                </div>
              )}
            </div>

            <div className="accordion-item">
              <div
                className="accordion-header"
                onClick={() => toggleSection("returns")}
              >
                <span>RETURNS</span>
                {openSection === "returns" ? <FiChevronUp /> : <FiChevronDown />}
              </div>
              {openSection === "returns" && (
                <div className="accordion-content">
                  <p>
                    You have 100 days to return. You can register and create the label
                    through the <span className="underline">return portal</span>. When returning, $3.49 will be deducted from
                    your refund. Your refund will be issued to your original payment method.
                  </p>
                  <p>
                    Read more about returns <span className="underline">here</span>.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
